<template>
    <div>
        <slot name="head">
            <b-container v-if="bannerSize" fluid>
                <div :class="['banner', bannerSize]">
                    <img @error="imageLoadOnError" class="banner-img position-absolute" :src="internalBannerImg"/>
                    <div v-if="bannerLogo" class="h-100 text-center position-relative">
                        <img class="banner-logo" :src="fileResourceUrl(bannerLogo)"/>
                    </div>
                    <b-container>
                        <div class="title-wrapper">
                            <div v-html="bannerTitle" class="title-text"></div>
                            <div class="subtitle-text">{{ bannerSubTitle }}
                            </div>
                            <hr v-if="bannerTitle" class="left" style="border-color:white;height: 1px;">
                        </div>
                    </b-container>
                </div>
            </b-container>
        </slot>
        <div class="mt-3">
            <slot name="title">
                <b-container>
                    <b-row>
                        <b-col md="7">
                            <b-breadcrumb class="p-0 my-1" :items="compBreadcrumbs"/>
                            <h2 v-if="pageTitle">{{pageTitle}}</h2>
                            <hr v-if="pageTitle" class="left mt-1 mb-4"/>
                        </b-col>
                        <b-col md="5" align-self="end">
                            <slot name="settings"></slot>
                        </b-col>
                    </b-row>
                </b-container>
            </slot>
            <slot name="body">
                <b-container :v-html="pageContent">
                </b-container>
            </slot>
        </div>
    </div>
</template>

<script>

    import DefaultImage from '@shared/_assets/img/banner_categories.png';

    export default {
        name: 'pb-body',
        props: {
            bannerSize: {
                type: String
            },
            bannerImg: {
                type: String,
                default: null
            },
            bannerLogo: {
                type: String,
                default: null
            },
            bannerTitle: {
                type: String
            },
            bannerSubTitle: {
                type: String
            },
            breadcrumbs: {
                type: Array,
                default: () => []
            },
            pageTitle: {
                type: String
            },
            pageContent: {
                type: String
            },
            busy: {
                type: Boolean
            }
        },
        data: function () {
            return {
                internalBannerImg: (this.bannerImg || this.fileResourceUrl(this.$config['default_banner_image'])) || DefaultImage
            }
        },
        methods: {
            imageLoadOnError() {
                this.internalBannerImg = this.fileResourceUrl(this.$config['default_banner_image']) || DefaultImage;
            }
        },
        computed: {
            compBreadcrumbs: function () {
                if(this.breadcrumbs && this.breadcrumbs.length > 0) {
                    return [{
                        text: 'Home',
                        href: '/'
                    }].concat(this.breadcrumbs);
                }
                return []
            }
        },
    }
</script>

<style lang="scss" scoped>
    @import "~@shared/_assets/scss/constants";

    .banner {
        width: 100%;
        position: relative;
        margin-top: 5px;

        &.md {
            height: 500px;
        }

        &.sm {
            height: 300px;
        }

        .banner-logo {
            max-height: 300px;
            object-fit: contain;
            width: 100%;
            height: 100%;
            max-width: 300px;
        }

        .banner-img {
            object-fit: cover;
            width: 100%;
            height: 100%;
        }

        .title-wrapper {
            position: absolute;
            top: 50%;
            transform: translateY(-50%);

            .title-text {
                text-transform: uppercase;
                color: white;
                font-family: $font-robo;
                font-size: 40px;
                font-weight: 300;
                letter-spacing: 1px;
                line-height: 53px;
                text-shadow: 1px 1px 3px black;
            }

            .subtitle-text {
                font-family: $font-robo;
                font-size: 20px;
                color: white;
                letter-spacing: 1.11px;
                line-height: 26px;
            }
        }
    }

</style>